import type { Table } from "drizzle-orm";
import { sql } from "drizzle-orm";

/**
 * SQL expression that formats a MySQL DATETIME/TIMESTAMP column as an
 * ISO 8601 string with full sub-second precision (microseconds).
 * Use this in SELECT instead of selecting the raw column + converting in JS.
 * This avoids JavaScript Date's millisecond precision limit which can break
 * cursor-based pagination.
 *
 * Usage: `db.select({ createdAt: dateTimeToISO(quotesTable, "createdAt") })`
 */
export function dateTimeToISO<TTable extends Table>(
	table: TTable,
	key: string & keyof TTable & keyof TTable["_"]["columns"],
) {
	return sql<string>`DATE_FORMAT(${table[key]}, '%Y-%m-%dT%H:%i:%s.%fZ')`.as(
		key,
	);
}

export function isNonEmpty<T>(arr: readonly T[]): arr is readonly [T, ...T[]] {
	return arr.length > 0;
}

export function decodeRouteParam(value: string): string {
	try {
		return decodeURIComponent(value);
	} catch {
		return value;
	}
}

export function removeProperties<T>(
	obj: Record<string, T>,
	isPropertyToRemove: (arg: [key: string, value: unknown]) => boolean,
): Record<string, T> {
	return Object.fromEntries(
		Object.entries(obj).filter(([key, value]) => {
			return !isPropertyToRemove([key, value]);
		}),
	);
}
